import { render, staticRenderFns } from "./IpAdditionalOutcomesForm.vue?vue&type=template&id=51413780&scoped=true&"
import script from "./IpAdditionalOutcomesForm.vue?vue&type=script&lang=js&"
export * from "./IpAdditionalOutcomesForm.vue?vue&type=script&lang=js&"
import style0 from "./IpAdditionalOutcomesForm.vue?vue&type=style&index=0&id=51413780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51413780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VChip,VCombobox,VFlex,VForm,VLayout,VSpacer})
